import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AuthService } from './services/auth/auth.service';
import { filter, take } from 'rxjs';
import { LoadingComponent } from './components/loading/loading.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    RouterOutlet,
    LoadingComponent
  ]
})
export class AppComponent implements OnInit {

  private _authService = inject(AuthService);
  private _router = inject(Router);
  private _title = inject(Title);
  version = environment.version;

  ngOnInit(): void {
    this._title.setTitle(environment.appName);
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const urlTree = this._router.parseUrl(this._router.url);

      let queryParamsChanged = false;
      for (const key of Object.keys(urlTree.queryParams)) {
        if (key.startsWith('utm_') || key === 'fbclid') {
          delete urlTree.queryParams[key];
          queryParamsChanged = true;
        }
      }

      if (queryParamsChanged) {
        this._router.navigateByUrl(urlTree, { replaceUrl: true });
        return;
      }

      const currentPath = urlTree.root.children['primary'] 
        ? '/' + urlTree.root.children['primary'].segments.map(it => it.path).join('/') 
        : '/';

      const isPublicRoute = currentPath === '/' || currentPath.includes('/login') || currentPath.includes('/register') || currentPath.includes('/privacy-policy') || currentPath.includes('/terms-and-conditions');
      
      this._authService.isLoggedIn.pipe(take(1)).subscribe(loggedIn => {
        if (!loggedIn && !isPublicRoute) {
          this._router.navigate(['/login']);
        }
      });
    });
  }
}
